import * as yup from 'yup';

const testsEditFormValidationSchema = yup.object().shape({
  language: yup.string().required('error.required').trim(),
  title: yup.string().required('error.required').trim(),
  correctAnswer: yup.string().required('error.required').trim(),
  answers: yup.array().of(yup.string().required('error.required')),
  direction: yup.string().required('error.required').trim(),
  category: yup.string().required('error.required').trim(),
  difficultyLevel: yup.string().required('error.required').trim(),
  field: yup.string().required('error.required').trim(),
});

export default testsEditFormValidationSchema;
